// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

const TaliupWorkspacePage = () => import('@/modules/taliup/views/TaliupWorkspacePage')
const TaliupDashboard = () => import('@/modules/taliup/views/TaliupDashboard')
const UnAssignedTab = () => import('@/modules/taliup/views/UnAssignedTab')
const FeePendingTab = () => import('@/modules/taliup/views/FeePendingTab')
const PendingSetupTab = () => import('@/modules/taliup/views/PendingSetupTab')
const PoyntHqSetupTab = () => import('@/modules/taliup/views/PoyntHqSetupTab')
const TaliupRegisterSetupTab = () => import('@/modules/taliup/views/TaliupRegisterSetupTab')
const AppLayoutSetupTab = () => import('@/modules/taliup/views/AppLayoutSetupTab')
const PendingCatalogBuildTab = () => import('@/modules/taliup/views/PendingCatalogBuildTab')
const CompleteTab = () => import('@/modules/taliup/views/CompleteTab')

var routes = [
    {
        path: '/taliup',
        redirect: '/taliup/orders',
        name: 'Taliup',
        component: DefaultContainer,
        children: [
            {
				path: '/taliup',
                name: 'TaliupWorkspacePage',
				redirect: '/taliup/dashboard',
                component: TaliupWorkspacePage,
				children: [
					{
						path: 'dashboard',
						name: 'TaliupDashboard',
						component: TaliupDashboard,
						meta: {
							tab: 'dashboard',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'unassigned',
						name: 'UnAssignedTab',
						component: UnAssignedTab,
						meta: {
							tab: 'unassigned',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'fee-pending',
						name: 'FeePendingTab',
						component: FeePendingTab,
						meta: {
							tab: 'fee-pending',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'pending-setup',
						name: 'PendingSetupTab',
						component: PendingSetupTab,
						meta: {
							tab: 'pending-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'poynt-hq-setup',
						name: 'PoyntHqSetupTab',
						component: PoyntHqSetupTab,
						meta: {
							tab: 'poynt-hq-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'taliup-register-setup',
						name: 'TaliupRegisterSetupTab',
						component: TaliupRegisterSetupTab,
						meta: {
							tab: 'taliup-register-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'app-layout-setup',
						name: 'AppLayoutSetupTab',
						component: AppLayoutSetupTab,
						meta: {
							tab: 'app-layout-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'pending-catalog-build',
						name: 'PendingCatalogBuildTab',
						component: PendingCatalogBuildTab,
						meta: {
							tab: 'pending-catalog-build',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'complete',
						name: 'CompleteTab',
						component: CompleteTab,
						meta: {
							tab: 'complete',
							role_filter: 'installation_rep',
						},
					},
				]
            },
        ]
    },
];

export default routes;
